export default __webpack_public_path__ + "static/media/nextjs.bbee347b.svg";